export function setcontacts_mails(state, contacts_mails) {
    state.contacts_mails = contacts_mails
}

export function setcontacts_mails_send(state, contacs_selected) {
    if (contacs_selected.select_email) {
        var selecteds = state.contacs_selecteds.filter(function (car) {
            return car.id_contact !== contacs_selected.id_contact;
        });
        state.contacs_selecteds = selecteds;
        state.contacs_selecteds.push(contacs_selected);
    } else {
        var selecteds = state.contacs_selecteds.filter(function (car) {
            return car.id_contact !== contacs_selected.id_contact;
        });
        state.contacs_selecteds = [];
        state.contacs_selecteds = selecteds;
    }

    console.log(state.contacs_selecteds);
}

export function setSellers(state, sellers) {
    state.sellers = sellers;
}

export function setupdate_mails_send(state, type_format_change){
    if(state.contacs_selecteds){
        let select = state.contacs_selecteds;
        select.map(function(dato){

              dato.type_informe = type_format_change;

            
            return dato;
          });
        state.contacs_selecteds = select;

        console.log(state.contacs_selecteds);
    }else{
        return false;
    }
}

export function setSubscriber(state, subscriber) {
    state.subscriber = subscriber
}


// WEBPACK FOOTER //
// ./src/modules/masive-mails/mutations.js